<template>
    <UModal
        v-model:open="open"
        :title="$t('claude_account.start_with')"
        :ui="{ content: 'mx-4 w-full sm:w-2/3 md:w-1/2 lg:w-2/5 max-w-none' }"
        @update:open="(value: boolean) => { if (!value) resolveClaudeAccountPick(null) }"
    >
        <template #body>
            <USelect
                v-model="selected"
                class="w-full"
                :items="options"
                value-key="value"
            />

            <div class="flex justify-end gap-2 mt-5">
                <UButton
                    color="neutral"
                    :label="$t('general.cancel')"
                    variant="subtle"
                    @click="resolveClaudeAccountPick(null)"
                />
                <UButton
                    icon="i-lucide-play"
                    :label="$t('project.start')"
                    @click="resolveClaudeAccountPick(selected)"
                />
            </div>
        </template>
    </UModal>
</template>

<script lang="ts" setup>
    import { computed, ref, watch } from 'vue'

    import {
        claudeAccountPickerOpen,
        claudeAccounts,
        defaultClaudeAccount,
        resolveClaudeAccountPick,
    } from '@/libs/claudeAccount'
    import type { SelectOption } from '@/types/Common'

    const open     = claudeAccountPickerOpen
    const selected = ref('')

    const options = computed((): SelectOption[] =>
        claudeAccounts().map(account => ({ label: account.label, value: account.id })))

    // The default is what a start would have used anyway, so it is what the dialog opens on.
    watch(open, (value) => {
        if (value) selected.value = defaultClaudeAccount()?.id ?? ''
    })
</script>
